import React from 'react';
import PropTypes from 'prop-types';

import GiftCard from './GiftCard';
import GiftCardMessage from '../GiftCardMessage';
import OrderInformation from './OrderInformation';
import CheckoutButton from '../../reservation/components/StripeCheckoutButton';
import ContactInformation from '../../reservation/containers/ContactInformation';
import ProcessingIndicator from '../../reservation/containers/ProcessingIndicator';

const Checkout = ({ currency, gcAmount, user, paymentEnabled, checkout }) => (
  <div>
    <GiftCardMessage className="u-mt u-mb" />
    <div className="layout layout--flush">
      <div className="layout__item u-2/3-small-plus-and-up">
        <GiftCard />
        <ContactInformation />
      </div>

      <div className="layout__item u-1/3-small-plus-and-up ">
        <div className="u-mt+ small-plus-and-up-ml+ small-plus-and-up-pl small-plus-and-up-mt0">
          <OrderInformation gcAmount={gcAmount} />
          <CheckoutButton
            className="c-btn c-btn--primary u-1/1 u-mb-"
            onSuccess={checkout}
            currency={currency}
            amount={gcAmount}
            email={user.email}
            disabled={!paymentEnabled}
          >
            Buy Now
          </CheckoutButton>
        </div>
      </div>
    </div>
    <ProcessingIndicator>Processing order</ProcessingIndicator>
  </div>
);

Checkout.propTypes = {
  currency: PropTypes.string.isRequired,
  gcAmount: PropTypes.number.isRequired,
  user: PropTypes.shape({ email: PropTypes.string }).isRequired,
  paymentEnabled: PropTypes.bool.isRequired,
  checkout: PropTypes.func.isRequired,
};

export default Checkout;



// WEBPACK FOOTER //
// ./src/app/giftCard/Checkout/Checkout.jsx